import React, { useState } from 'react';
import { Button, Popover, Typography } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import PwaInstallHelpModal from './PwaInstallHelpModal';
import '../styles/pwa-install.css';

const { Text } = Typography;

export default function PwaInstallFab({
  visible,
  manualInstallMode = 'desktop',
  helpModalMode = 'desktop',
  helpOpen,
  onHelpOpenChange,
  onInstall,
  onDismiss,
}) {
  const { t } = useTranslation();
  const [installing, setInstalling] = useState(false);
  const [popoverOpen, setPopoverOpen] = useState(false);

  if (!visible && !helpOpen) {
    return null;
  }

  const hintText = (() => {
    if (manualInstallMode === 'native') return t('common.installMobileAppHint');
    if (manualInstallMode === 'ios') return t('common.installIosIntro');
    if (manualInstallMode === 'android') return t('common.installAndroidIntro');
    return t('common.installDesktopIntro');
  })();

  const runInstall = async () => {
    setInstalling(true);
    try {
      const result = await onInstall();
      if (result?.outcome === 'accepted') {
        setPopoverOpen(false);
        onHelpOpenChange(false);
      }
    } finally {
      setInstalling(false);
    }
  };

  const popoverContent = (
    <div className="pwa-install-popover">
      <Text strong className="pwa-install-popover__title">
        {t('common.installMobileApp')}
      </Text>
      <Text type="secondary" className="pwa-install-popover__desc">
        {hintText}
      </Text>
      <div className="pwa-install-popover__actions">
        <Button type="primary" size="small" loading={installing} onClick={runInstall}>
          {manualInstallMode === 'native' ? t('common.installNow') : t('common.installShowSteps')}
        </Button>
        <Button
          type="text"
          size="small"
          onClick={() => {
            setPopoverOpen(false);
            onDismiss();
          }}
        >
          {t('common.notNow')}
        </Button>
      </div>
    </div>
  );

  return (
    <>
      {visible && (
        <Popover
          content={popoverContent}
          trigger="click"
          open={popoverOpen}
          onOpenChange={setPopoverOpen}
          placement="topRight"
          overlayClassName="pwa-install-popover-overlay"
        >
          <Button
            type="primary"
            className="pwa-install-fab"
            icon={<DownloadOutlined />}
            aria-label={t('common.installMobileApp')}
          >
            <span className="pwa-install-fab__label">{t('common.installNow')}</span>
          </Button>
        </Popover>
      )}

      <PwaInstallHelpModal
        open={helpOpen}
        mode={helpModalMode}
        onClose={() => onHelpOpenChange(false)}
      />
    </>
  );
}
